import { Button, Container, Form } from 'react-bootstrap';
import { useState } from 'react';

import { db } from '../../ReactNative/firebase';
import { child, get, ref } from 'firebase/database';
import { useNavigate } from 'react-router-dom';

const PapaLads = () => {
    const [name, setName] = useInput({type: 'text'})
    const [email, setEmail] = useInput({ type: 'email'})
    const navigate = useNavigate()

    function useInput({ type }) {
        const [value, setValue] = useState("");
        const input = <input value={value} onChange={e => setValue(e.target.value)} type={type} />
        return [value, input];
    }

    const startQuiz = (e) => {
        e.preventDefault();
    
        if (!name) {
            alert("Please type your name first.");
            return;
        }
    
        if (!email) {
            alert("Please type your email, too.");
            return;
        }
    
        const startTime = Date.now();
    
        sessionStorage.setItem('PapaLadsTriviaStartTime', startTime);
        sessionStorage.setItem('PapaLadsTriviaEmail', email);
        sessionStorage.setItem('PapaLadsTriviaName', name);
        sessionStorage.setItem('PapaLadsTriviaStarted', 'true');
    
        const dbRef = ref(db);
    
        get(child(dbRef, 'PapaLadsTriviaScoreboard/')).then(snap => {
            let foundEmail = false;
    
            const data = snap.val() || [];
    
            for (let i = 0; i < data.length; i++) {
                if (
                    email.toLowerCase() === data[i]?.email?.toLowerCase()
                ) {
                    alert("You already took the quiz with this email.");
                    foundEmail = true;
                    break;
                }
            }
    
            if (!foundEmail) {
                navigate('/QuizTrivias/June2026/papaladstrivia');
            }
        });
    };

    return (
            <>
                <Container className="keiki-party papalads-70th">

                <h1 className="ycustom-banner neonText-gold papa-entry-title">
                    Papa Ladz 70th Trivia
                </h1>

                <div className="papa-entry-wrapper">

                    <div className="papa-entry-card">

                        <Form onSubmit={startQuiz} className="papa-entry-form">

                            <h3 className="papa-entry-subtitle">
                                Enter your details to continue
                            </h3>

                            <div className="papa-input-group">
                                <Form.Label>Name:</Form.Label>
                                <div className="papa-input">
                                    {setName}
                                </div>
                            </div>

                            <div className="papa-input-group">
                                <Form.Label>Email:</Form.Label>
                                <div className="papa-input">
                                    {setEmail}
                                </div>
                            </div>

                            <Button type="submit" className="papa-start-btn">
                                Start Trivia
                            </Button>

                        </Form>

                    </div>

                </div>

                </Container>
            </>
    )
}

export default PapaLads;